import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { easeOut, motion } from 'framer-motion';
import './MySkills.css'


const data = [
    {
        name: "Framer",
        duration:0.1
    },
    {
        name: "Figma",
        duration:0.2
    },
    {
        name: "Figjam",
        duration:0.3
    },
    {
        name: "Miro",
        duration:0.4
    },
    {
        name: "Jira",
        duration:0.5
    },
    {
        name: "Jira",
        duration:0.6
    },
    {
        name: "Adobe XD",
        duration:0.7
    },
    {
        name: "Iliiustrator",
        duration:0.8
    },
    {
        name: "Photoshop",
        duration:0.9
    },
    {
        name: "Webflow",
        duration:0.1
    },
    {
        name: "VS Code",
        duration:0.2
    },
    {
        name: "Canvas",
        duration:0.3
    },
    {
        name: "After-Effects",
        duration:0.4
    },
    {
        name: "Premiere-Pro",
        duration:0.5
    },
    {
        name: "exgif",
        duration:0.6
    },
    {
        name: "Invision Studio",
        duration:0.7
    },
    {
        name: "vectary 3D",
        duration:0.8
    },

]


const Tools = (props) => {
    return (
        <Col xs={6} md={3} lg={3} >
            <motion.div initial={{ opacity: 0, }} whileInView={{ opacity: 1, }} transition={{ duration: props.data.duration, delay: 0.5, timingFunction: easeOut }} viewport={{ once: true }} >
                <div className="myRole" >
                    <center>
                        {props.data.name}
                    </center>
                </div>
            </motion.div>

        </Col>
    )
}



function MyTools() {
    return (
        <Container fluid className="MyToolsPage">
            <Row>
                <Col xs={12} md={3} lg={3}>

                    <motion.div initial={{ opacity: 0, }} whileInView={{ opacity: 1, }} transition={{ duration: 0.5, delay: 0.3, timingFunction: easeOut }} >
                        <div className="aboutHeading_designprocess" >Software<br />&Tools</div>
                        <p className="headingText">I have ability to work effectivelly on the following skills below and this will be very cool</p>
                    </motion.div>

                    <br />
                </Col>
                <Col xs={12} md={9} lg={9}>
                    <Row style={{ paddingTop: 3 + 'rem' }}>
                        {
                            data.map((item, index) => {
                                return (
                                    <>
                                        <Tools key={index} data={item} />
                                    </>

                                )
                            })
                        }
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

export default MyTools;